const COMMENTS = [
  {
    name: '追剧达人小王',
    avatar: '王',
    date: '2天前',
    content: '红桃影视真的太良心了！1080P高清画质还免费，追《繁华似锦》全程无卡顿，比那些要充会员的平台好太多了。已经推荐给身边所有剧迷朋友了！',
    likes: '328',
    tag: '忠实用户',
  },
  {
    name: '韩剧控小美',
    avatar: '美',
    date: '3天前',
    content: '终于找到一个韩剧更新超快的平台了！《逆光之恋》韩国刚播这边就有中字版，翻译质量也很高，追剧体验满分。希望多上一些经典老剧～',
    likes: '256',
    tag: '韩剧迷',
  },
  {
    name: '老剧爱好者',
    avatar: '老',
    date: '5天前',
    content: '4K修复版《长安十二时辰》画质惊艳到我了，跟看新剧一样。红桃影视对经典剧集的重视让人感动，希望能修复更多老剧的4K版本。',
    likes: '189',
    tag: '经典粉',
  },
  {
    name: '阿杰不爱剧透',
    avatar: '杰',
    date: '1周前',
    content: '作为一个重度追剧人，红桃影视的日更速度真的无敌。每天上班摸鱼偷偷刷几集，下班回家继续看，生活因追剧而美好。唯一建议是能不能加个夜间模式？',
    likes: '142',
    tag: '活跃用户',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100/60 text-primary-600 text-xs font-medium mb-4">
              用户心声
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              剧迷热评
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              听听红桃影视用户怎么说，一起加入追剧大家庭
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {COMMENTS.map((comment, i) => (
              <div key={i} className="p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/40 hover:border-primary-500/20 transition-all duration-200 cursor-pointer">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/15 text-primary-400 font-bold text-sm flex-shrink-0">
                    {comment.avatar}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{comment.name}</span>
                      <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100/70 text-accent-700 font-medium whitespace-nowrap">{comment.tag}</span>
                    </div>
                    <span className="text-xs text-foreground-400">{comment.date}</span>
                  </div>
                  <div className="flex items-center gap-1 text-foreground-400">
                    <i className="ri-thumb-up-line text-sm"></i>
                    <span className="text-xs">{comment.likes}</span>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}